import React, { useState, useMemo, useEffect } from 'react';
import Select from 'react-select'
import N3rveLogo from './../../../images/N3rveLogo.png'
import DropDownIcon from './../../../images/dropdownicon.png'
import './AccountDetails.css'
import countryList from 'react-select-country-list'
// import SelectCurrency from 'react-select-currency'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import axios from 'axios';
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next"
import { logtoWix } from '../../Helpers/LogToWix';


function AccountDetails() {
  const [role, setRole] = useState("")
  const location = useLocation()
  const { email } = location.state
  // const [email,onChangeEmail] = useState(location.state.email)
  const [fname, setFname] = useState("")
  const [lname, setLname] = useState("")
  const [roleError, setRoleError] = useState(false)
  const [fnameError, setFnameError] = useState(false)
  const [lnameError, setLnameError] = useState(false)
  const [countryError, setCountryError] = useState(false)
  const [currencyError, setCurrencyError] = useState(false)
  const [country, setCountry] = useState("")
  const [currency, setCurrency] = useState("")
  const cookies = new Cookies(null, { path: '/' });
  const options = useMemo(() => countryList().getData(), [])
  const currencyOptions = [{ value: 'KRW', label: 'Korean Won (KRW)' },
  { value: 'USD', label: 'United States Dollar (USD)' },
  { value: 'HKD', label: 'Hong Kong Dollar (HKD)' }]
  const { t, i18n } = useTranslation();

  const changeCountryHandler = value => {
    setCountry(value)
  }

  const changeCurrencyHandler = value => {
    setCurrency(value)
  }

  useEffect(() => {
    console.log("Email")
    console.log(email)
  }, [])

  const navigate = useNavigate();


  //   const onSelectedCurrency = currencyAbbrev => {var debug=true
  //     debug(`Selected ${currencyAbbrev}`)
  // }

  const colourStyles = {
    control: styles => ({
      ...styles, borderColor: '#636468',
      backgroundColor: '#18191F',
      width: '26em',
      height: '3em',
      borderRadius: '4px',
      color: 'rgba(255, 255, 255, 1)',
      marginTop: '1.2em',
      marginLeft: '-1em'
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: '#18191F',
        color: 'rgba(255, 255, 255, 1)',
        cursor: isDisabled ? 'not-allowed' : 'default',
        marginTop: '-0.3em',
        marginBottom: '-0.3em',
      };
    },
    input: (styles) => ({
      ...styles,
      FontFamily: 'ClashGrotesk-Variable,sans-serif',
      FontSize: '1rem',
      FontWeight: 'medium',
      LineHeight: '150%',
      LetterSpacing: '0%',
      color: 'rgba(255, 255, 255, 1)'
    }),
    singleValue: (styles) => ({
      ...styles,
      color: 'rgba(255, 255, 255, 1)',
      FontFamily: 'ClashGrotesk-Variable,sans-serif',
      FontSize: '1rem',
      FontWeight: 'medium',
      LineHeight: '150%',
      LetterSpacing: '0%'
    })
  };

  const ErrorcolourStyles = {
    control: styles => ({
      ...styles, borderColor: '#FF6363',
      backgroundColor: '#18191F',
      width: '25em',
      height: '3em',
      borderRadius: '8px',
      color: 'rgba(255, 255, 255, 1)',
      marginTop: '1.2em'
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: '#18191F',
        color: 'rgba(255, 255, 255, 1)',
        cursor: isDisabled ? 'not-allowed' : 'default',
        marginTop: '-0.3em',
        marginBottom: '-0.3em'
      };
    },
    input: (styles) => ({
      ...styles,
      FontFamily: 'ClashGrotesk-Variable,sans-serif',
      FontSize: '1rem',
      FontWeight: 'medium',
      LineHeight: '150%',
      LetterSpacing: '0%',
      color: 'rgba(255, 255, 255, 1)'
    }),
    singleValue: (styles) => ({
      ...styles,
      color: 'rgba(255, 255, 255, 1)',
      FontFamily: 'ClashGrotesk-Variable,sans-serif',
      FontSize: '1rem',
      FontWeight: 'medium',
      LineHeight: '150%',
      LetterSpacing: '0%'
    })
  };

  const handleSubmit = () => {

    if (role.length === 0) {
      setRoleError(true)
    } else {
      setRoleError(false)
    }

    if (fname.length === 0) {
      setFnameError(true)
    } else {
      setFnameError(false)
    }

    if (lname.length === 0) {
      setLnameError(true)
    } else {
      setLnameError(false)
    }

    if (country.length === 0) {
      setCountryError(true)
    } else {
      setCountryError(false)
    }

    console.log(currency.value)
    if (currency.length === 0) {
      setCurrencyError(true)
    } else {
      setCurrencyError(false)
    }

    if (!roleError && !fnameError && !lnameError && !countryError && !currencyError) {
      handleAccountDetails()
    }


  }

  const handleAccountDetails = () => {

    axios({
      method: 'post',
      url: "https://n3rve.fly.dev/auth/signup/details",
      headers: {
        Authorization: "Bearer ".concat(cookies.get("token"))
      },
      data: {
        email: email,
        role: role,
        firstName: fname,
        lastName: lname,
        country: String(country),
        currency: currency.value
      }
    }).then((response) => {
      if (response.status === 200) {
        logtoWix(email, "auth", "Account Details Page", { "desc": "Successful account details", "role": role, "fisrtname": fname, "lastname": lname, "country": String(country), "currency": currency.value })
        cookies.set('token', response.data.token)
        if (role === "artist" || role === "producer") {
          navigate("/Dashboard", { state: { fromAccountPage: true, fromLogin: true } })
        }
        if (role === "label") {
          navigate("/dashboard/label", { state: { fromAccountPage: true, fromLogin: true } })
        }
      }
    }).catch(function (e) {
      logtoWix(email, "auth", "Account Details Page", { "desc": "Unsuccessful account details" })
      console.log(e.response)
    })



  }

  return (
    <div className="AccountDetailsContainer" style={{ height: '100vh', overflowY: 'scroll' }}>
      <img src={N3rveLogo} alt="Nerve Logo" style={{ width: '5.58em', height: '1em', marginLeft: '9.5em', marginTop: '1.75em' }} />

      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div className='TellUsRoleTxt'>
          <Trans i18nKey="Tellusaboutyourrole" components={{ 1: <br /> }}
          > Tell Us About <br /> Your Role
          </Trans>

        </div>

        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '7em', marginLeft: '6em' }}>
          <div className='YourInfoTxt'>{t('Yourinfo')}</div>

          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div className='FormHeader' style={{ marginLeft: '0em' }}>
                {t('Selectyourrole')}
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginRight: '10.5em' }}>
                {
                  role === "artist" &&
                  <div className='RoleBubbleSelected' style={{ cursor: 'pointer' }}>{t('artist')}</div>
                }

                {
                  role !== "artist" &&
                  <div className='RoleBubble' onClick={() => setRole("artist")} style={{ cursor: 'pointer' }}>{t('artist')}</div>
                }

                {
                  role === "producer" &&
                  <div className='RoleBubbleSelected' style={{ cursor: 'pointer' }}>{t('producer')}</div>
                }

                {
                  role !== "producer" &&
                  <div className='RoleBubble' onClick={() => setRole("producer")} style={{ cursor: 'pointer' }}>{t('producer')}</div>
                }

                {
                  role === "label" &&
                  <div className='RoleBubbleSelected' style={{ cursor: 'pointer' }}>{t('label')}</div>
                }

                {
                  role !== "label" &&
                  <div className='RoleBubble' onClick={() => setRole("label")} style={{ cursor: 'pointer' }}>{t('label')}</div>
                }

              </div>

              {
                roleError &&
                <div className='ErrorTxt' style={{ marginTop: '1em' }}>Role cannot be empty</div>
              }
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '-5em' }} >
              <div className='FormHeader' style={{ marginLeft: '0em' }}>
                {t('Email')}
              </div>

              <input
                value={email}
                // onChange={e => onChangeEmail(e.target.value)} 
                className='FormInput'
                style={{ backgroundColor: 'rgba(0,0,0,16%)', border: '0.5px solid rgba(255,255,255,40%)', width: '25em', borderRadius: '4px', height: '3em' }}
                type='email'
                disabled
              />

            </div>

          </div>

          <div style={{ display: 'flex', flexDirection: 'row' }}>

            <div style={{ display: 'flex', flexDirection: 'column' }} >
              <div className='FormHeader' style={{ marginLeft: '0em' }}>
                {t('Firstname')}
              </div>

              {
                !fnameError &&
                <input
                  value={fname}
                  onChange={e => setFname(e.target.value)}
                  className='FormInput'
                  style={{ backgroundColor: 'rgba(0,0,0,16%)', border: '0.5px solid rgba(255,255,255,40%)', width: '25em', borderRadius: '4px', height: '3em' }}
                  type='text'
                />
              }

              {
                fnameError &&
                <input
                  value={fname}
                  onChange={e => setFname(e.target.value)}
                  className='FormInput'
                  style={{ backgroundColor: 'rgba(0,0,0,16%)', border: '1px #FF6363 solid', width: '25em', borderRadius: '4px', height: '3em' }}
                  type='text'
                />
              }

              {
                fnameError &&
                <div className='ErrorTxt'>First Name cannot be empty</div>
              }


            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }} >
              <div className='FormHeader' style={{ marginLeft: '-1em' }}>
                {t('Countryofresidence')}
              </div>

              {
                !countryError &&
                <Select options={options} value={country} onChange={changeCountryHandler}
                  components={{
                    IndicatorSeparator: () => null
                  }}
                  styles={
                    colourStyles
                  }
                />
              }

              {
                countryError &&
                <Select options={options} value={country} onChange={changeCountryHandler}
                  components={{
                    IndicatorSeparator: () => null
                  }}
                  styles={
                    ErrorcolourStyles
                  }
                />
              }

              {
                countryError &&
                <div className='ErrorTxt' style={{ marginTop: '1em' }}>Country of Residence cannot be empty</div>
              }


            </div>
          </div>


          <div style={{ display: 'flex', flexDirection: 'row' }}>

            <div style={{ display: 'flex', flexDirection: 'column' }} >
              <div className='FormHeader' style={{ marginLeft: '0em' }}>
                {t('Lastname')}
              </div>

              {
                !lnameError &&
                <input
                  value={lname}
                  onChange={e => setLname(e.target.value)}
                  style={{ backgroundColor: 'rgba(0,0,0,16%)', border: '0.5px solid rgba(255,255,255,40%)', width: '25em', borderRadius: '4px', height: '3em' }}
                  className='FormInput'
                  type='text'
                />
              }

              {
                lnameError &&
                <input
                  value={lname}
                  onChange={e => setLname(e.target.value)}
                  style={{ backgroundColor: 'rgba(0,0,0,16%)', border: '1px #FF6363 solid', width: '25em', borderRadius: '4px', height: '3em' }}
                  className='FormInput'
                  type='text'
                />
              }

              {
                lnameError &&
                <div className='ErrorTxt'>Last Name cannot be empty</div>
              }


            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }} >
              <div className='FormHeader' style={{ marginLeft: '-1em' }}>
                {t('Preferenceofcurrency')}
              </div>

              {
                !currencyError &&
                <Select options={currencyOptions} value={currency} onChange={changeCurrencyHandler}
                  components={{
                    IndicatorSeparator: () => null
                  }}
                  styles={
                    colourStyles
                  }
                />
              }

              {
                currencyError &&
                <Select options={currencyOptions} value={currency} onChange={changeCurrencyHandler}
                  components={{
                    IndicatorSeparator: () => null
                  }}
                  styles={
                    ErrorcolourStyles
                  }
                />
              }

              {
                currencyError &&
                <div className='ErrorTxt' style={{ marginTop: '1em' }}>Preference of Currency cannot be empty</div>
              }


            </div>
          </div>
          {/* <Link to="/Dashboard" state={{ fromAccountPage: true }} className='ContinueBtn' style={{textDecoration:'none'}}> */}
          {
            (role.length === 0 || fname.length === 0 || lname.length === 0 || country.length === 0 || currency.length === 0) &&
            <div className='ContinueBtn' style={{ backgroundColor: '#821D41', color: '#8D9297', cursor: 'auto' }}>
              {t('Continue')}
            </div>

          }

          {
            role.length !== 0 && fname.length !== 0 && lname.length !== 0 && country.length !== 0 && currency.length !== 0 &&
            <div onClick={() => handleSubmit()} className='ContinueBtn' style={{ cursor: 'pointer' }}>
              {t('Continue')}
            </div>
          }


          {/* </Link> */}
        </div>


      </div>
    </div>
  );
}

export default AccountDetails;